import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';

const LockIcon = ({ Style }) => (
  <div className={Style.lock}>
    <Icon icon="lock" color="white" size="full" />
  </div>
);

export default LockIcon;

LockIcon.defaultProps = {
  Style: {},
};

LockIcon.propTypes = {
  Style: PropTypes.shape({}),
};
